import React from "react";

function Maintenance() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="maintenance-container text-center bg-white p-6 sm:p-10 md:p-12 lg:p-16 xl:p-20 rounded-2xl shadow-lg">
        <div className="message-box">
         
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            We're currently undergoing Maintenance! 
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-4">
            Our website is being improved. We'll be back shortly. Thank you for your patience!
          </p>
          <p className="text-sm sm:text-md md:text-lg text-gray-600 mb-6">
            This update is coming soon, and we appreciate your understanding.
          </p>
          <p className="text-sm sm:text-md md:text-lg text-gray-500">
            If you have any urgent inquiries, feel free to contact support.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Maintenance;
